import { validateArguments } from '../../SignatureValidation';
import { ExprValue } from '../ExprValue';
export var RunningSumFn;
(function (RunningSumFn) {
    RunningSumFn.Name = `RUNNING_SUM`;
    RunningSumFn.Stage = "ANALYTIC";
    RunningSumFn.Signature = `RUNNING_SUM(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: RunningSumFn.Name,
            stage: RunningSumFn.Stage,
            data: { type, role },
            init() {
                return {
                    sum: null,
                };
            },
            value(context, values) {
                var _a;
                const { state, frame: { index }, } = context;
                const value = values[index];
                if (ExprValue.isNumberValue(value)) {
                    state.sum = ExprValue.add((_a = state.sum) !== null && _a !== void 0 ? _a : 0, value);
                }
                return {
                    value: state.sum,
                    state,
                };
            },
        };
    }
    RunningSumFn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            meta: { name: RunningSumFn.Name, signature: RunningSumFn.Signature, location: callNode.location },
            arguments: [
                {
                    type: "NUMERIC",
                    stages: ["ANALYTIC", "AGGREGATE", "CONST"],
                },
            ],
        };
        return validateArguments(sig, args);
    }
    RunningSumFn.validate = validate;
})(RunningSumFn || (RunningSumFn = {}));
